module.exports = __webpack_public_path__ + "static/media/word.7da0f28b.svg";